export enum TOSIPTypes {
    Whitelist = 0,
    Blacklist = 1
}

export class TOSIP {
    ID: number;
    MemberID: number;
    AdminID: number;
    DateTimeCreated: Date;
    IP: string;


    static FixDate(item: TOSIP) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
    }

}

export class TOSIPArray extends Array<TOSIP>  {

    constructor(...items: TOSIP[]) {
        super(...items);
        Object.setPrototypeOf(this, TOSIPArray.prototype);
    }

    static FixDates(items: TOSIPArray) {
        items.forEach(x => { TOSIP.FixDate(x); });
    }

}
